// extracted by css-extract-rspack-plugin
export default {"Dialog":"CreateTagDialog-module__Dialog__MD5s3"};